__turbopack_context__.v({
  "actionIcon": "CResourceReservation-module__gZBBDa__actionIcon",
  "backBtn": "CResourceReservation-module__gZBBDa__backBtn",
  "bookActions": "CResourceReservation-module__gZBBDa__bookActions",
  "bookHeader": "CResourceReservation-module__gZBBDa__bookHeader",
  "bookTitle": "CResourceReservation-module__gZBBDa__bookTitle",
  "cancelBtn": "CResourceReservation-module__gZBBDa__cancelBtn",
  "cancelMuted": "CResourceReservation-module__gZBBDa__cancelMuted",
  "dateCell": "CResourceReservation-module__gZBBDa__dateCell",
  "dateInput": "CResourceReservation-module__gZBBDa__dateInput",
  "dateLabel": "CResourceReservation-module__gZBBDa__dateLabel",
  "dateRow": "CResourceReservation-module__gZBBDa__dateRow",
  "note": "CResourceReservation-module__gZBBDa__note",
  "pageButton": "CResourceReservation-module__gZBBDa__pageButton",
  "pageInfo": "CResourceReservation-module__gZBBDa__pageInfo",
  "pagination": "CResourceReservation-module__gZBBDa__pagination",
  "reserveBtn": "CResourceReservation-module__gZBBDa__reserveBtn",
  "resourceCard": "CResourceReservation-module__gZBBDa__resourceCard",
  "resourceCardDesc": "CResourceReservation-module__gZBBDa__resourceCardDesc",
  "resourceCardMeta": "CResourceReservation-module__gZBBDa__resourceCardMeta",
  "resourceCardName": "CResourceReservation-module__gZBBDa__resourceCardName",
  "resourceGrid": "CResourceReservation-module__gZBBDa__resourceGrid",
  "resourceName": "CResourceReservation-module__gZBBDa__resourceName",
  "root": "CResourceReservation-module__gZBBDa__root",
  "searchWrap": "CResourceReservation-module__gZBBDa__searchWrap",
  "selectBtn": "CResourceReservation-module__gZBBDa__selectBtn",
  "slot": "CResourceReservation-module__gZBBDa__slot",
  "slotGrid": "CResourceReservation-module__gZBBDa__slotGrid",
  "slotSelected": "CResourceReservation-module__gZBBDa__slotSelected",
  "slotTaken": "CResourceReservation-module__gZBBDa__slotTaken",
  "sortIcon": "CResourceReservation-module__gZBBDa__sortIcon",
  "sortIconActive": "CResourceReservation-module__gZBBDa__sortIconActive",
  "tab": "CResourceReservation-module__gZBBDa__tab",
  "tabActive": "CResourceReservation-module__gZBBDa__tabActive",
  "table": "CResourceReservation-module__gZBBDa__table",
  "tableWrap": "CResourceReservation-module__gZBBDa__tableWrap",
  "tabs": "CResourceReservation-module__gZBBDa__tabs",
  "thInner": "CResourceReservation-module__gZBBDa__thInner",
  "thSortable": "CResourceReservation-module__gZBBDa__thSortable",
  "toolbar": "CResourceReservation-module__gZBBDa__toolbar",
  "truncatedHint": "CResourceReservation-module__gZBBDa__truncatedHint",
});
